<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="tabsStyle"
        title="tabs style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in tabsStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :propertyTriggers="property.mutations"
            :element="element"
            :module="module"
          />
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="styles"
        title="Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in styleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          />
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="activeStyle"
        title="active style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in activeStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          />
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
          @updateOpen="updateOpen"
          trigger="inactiveStyle"
          title="inactive style"
          :open="open"
      >
        <template slot="list">
          <component
            v-for="property in inactiveStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          />
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="contentStyle"
        title="content style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentStyleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :styles="property.styles"
            :is="property.component"
            :element="element"
            :module="module"
          />
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="advancedProperties"
        title="advanced"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in advancedProperties"
            :key="property.key"
            :is="property.component"
            :element="element"
          />
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ElementMenu from '../../contracts/ElementMenu'
  export default ElementMenu.extend({
    data() {
      return {
        open: 'tabsStyle',
      }
    },
    computed: {
      advancedProperties() {
        return this.parent.properties.advanced
      },
      tabsMutationTriggers() {
        return {
          'tabs-direction': {
            'FLEX_COL': [
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Width", value: 'WIDTH_1_5', touched: false}
                ],
                array: 'tabsClasses',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: 'Flex', value: 'FLEX_ROW', touched:false},
                  {property: 'FlexWrap', value: 'FLEX_WRAP', touched: false}
                ],
                array: 'containerClasses',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Width", value: 'WIDTH_4_5', touched: false}
                ],
                array: 'contentClasses'
              }
            ],
            'FLEX_ROW': [
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Width", value: 'WIDTH_FULL', touched: false}
                ],
                array: 'tabsClasses',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: 'Flex', value: 'FLEX_COL', touched: false},
                ],
                array: 'containerClasses',
              },
              {
                elements: [this.element],
                module: this.module,
                value: [
                  {property: "Width", value: 'WIDTH_FULL', touched: false}
                ],
                array: 'contentClasses',
              }
            ],
          }
        }
      },
      tabsStyleProperties() {
        let styles = []
        Object.keys(this.tabsMutationTriggers).forEach(trigger => {
          let style = this.parent.properties.tabsStyles.find(style => style.key == trigger)
          if (! style) {
            return
          }
          styles.push({...style, mutations: this.tabsMutationTriggers[trigger]})
        })
        return styles
      },
      contentStyleProperties() {
        return this.parent.properties.contentStyles
      },
      styleProperties() {
        return this.parent.properties.styles
      },
      activeStyleProperties() {
        return this.parent.properties.activeStyles
      },
      inactiveStyleProperties() {
        return this.parent.properties.inactiveStyles
      },
    }
  })
</script>